module.exports = __webpack_public_path__ + "img/20250818_1.bb58c21d.png";